import * as React from "react";
import { FieldWrapper, FieldWrapperPassThroughProps } from "../field-wrapper";
import { cn } from "../../../../utils/cn";

import "./input.css";

type BaseSelectProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> &
  FieldWrapperPassThroughProps & {
    className?: string;
    isRequired?: boolean;
  };

type ControlledSelectProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | number;
};

type UncontrolledSelectProps = {
  onChange?: undefined;
  value?: string | number;
};

type InputProps = BaseSelectProps &
  (ControlledSelectProps | UncontrolledSelectProps);

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type = "text", label, onChange, value, isRequired = true, ...props },
    ref,
  ) => {
    return (
      <FieldWrapper
        label={label}
        htmlFor={label}
        isRequired={isRequired}
      >
        <input
          ref={ref}
          type={type}
          className={cn("text-input with-border", className)}
          value={value}
          {...props}
          onChange={(e) => onChange?.(e)}
          required={isRequired}
        />
      </FieldWrapper>
    );
  },
);

Input.displayName = "Input";

export { Input };
